import React, { useState, useEffect } from "react";
import styles from "./BlackFriday.module.scss";
import { useNavigate, } from 'react-router-dom';

import BlackFridayBanner from "./BlackFridayBanner/BlackFridayBanner";

import BlackFridayHero from "images/heros/Black Friday/black-friday-hero.jpg";
import BlackFridayHeroMobile from "images/heros/Black Friday/black-friday-hero-mobile.png";

const getIsMobileWidth = () => {
    console.log(window.innerWidth);
    return window.innerWidth < 500;
}

const BlackFriday = () => {
    const navigate = useNavigate();

    const [isMobileWidth, setIsMobileWidth] = useState(getIsMobileWidth());

    useEffect(() => {
        window.addEventListener('resize', updateWindowSize);
    }, []);

    const updateWindowSize = () => {
        setIsMobileWidth(getIsMobileWidth())
    }

   

    return (
        <>
            <section className={`${styles.heroBackground}`}>
                <div className={styles.vignette} />
                <h2 className="text-center">Party games to play on your TV</h2>

                <div className={styles.hero}>
                    <div key={`black-friday-hero`} className={styles.carouselItem}>
                        <img src={BlackFridayHero} alt="" className={`${styles.carouselImage} ${isMobileWidth && styles.right}`} />
                        <div className={styles.overlay}></div>
                    </div>
                </div>
                <h3 className={styles.code} onClick={() => navigate("/?discountCode=FRIDAY50")}>USE CODE: <strong>FRIDAY50</strong></h3>
            </section>
            <BlackFridayBanner />
        </>
    );
};

export default BlackFriday;